import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { SearchInput } from "../../../components/inputs/searchInput";
import { CoopCardLoader } from "../../../components/loaders/coopCardLoader";
import { CooperativeProfilePic } from "../../../components/profile/cooperativePicture";
import { TableComponent } from "../../../components/table/table";
import { PageTitle } from "../../../components/typography/pageTitle";
import { useFetchAllApprovalsSummaryQuery } from "../../../redux/features/cooperative/cooperative.api";
import { ApprovalSummaryQuery } from "../../../redux/features/cooperative/cooperative.type";

export const Approvals = () => {
  const [query, setQuery] = useState<ApprovalSummaryQuery>({
    text: undefined,
  });

  const navigate = useNavigate();

  const { data: approvalSummary, isLoading: fetchingApprovalSummary } =
    useFetchAllApprovalsSummaryQuery(query, {
      refetchOnMountOrArgChange: true,
    });

  useEffect(() => {
    if (approvalSummary?.data && !approvalSummary?.data?.Official) {
      navigate("/app/overview", { replace: true });
    }
    // eslint-disable-next-line
  }, [approvalSummary]);

  return (
    <div className="w-full min-h-full flex flex-col gap-6">
      <PageTitle
        text="Approvals"
        subtext="Manage all your cooperative approvals in one place."
        containerClassName="max-md:hidden"
      />

      <SearchInput
        placeholder="Search cooperative name"
        searchFunction={(val) => {
          setQuery({ ...query, text: val });
        }}
      />

      <TableComponent
        headers={[]}
        rowClassName="max-md:first:!pl-4 max-md:last:!pr-4"
        rows={
          approvalSummary?.data?.approvalList
            ?.filter((e) => e.approvalCount > 0)
            ?.map((entry, idx) => {
              return {
                id: `${idx}-${entry.Cooperative.id}`,
                items: [
                  <div
                    key={`${entry.Cooperative.id}-approvals`}
                    className="flex flex-wrap gap-4 items-center"
                  >
                    <CooperativeProfilePic
                      cooperative={entry.Cooperative}
                      className="!w-[32px] !h-[32px] md:!w-[48px] md:!h-[48px]"
                    />

                    <p className="text-base text-pry-dark-green-100 font-medium flex-1">
                      {entry?.Cooperative?.CoopName}
                    </p>

                    <Button
                      text="Manage Approvals"
                      onClick={() => {
                        navigate(`/app/approvals/${entry.Cooperative?.id}`);
                      }}
                      type="button"
                      className="md:!w-fit"
                      loading={false}
                      disabled={entry.approvalCount === 0}
                      icon={undefined}
                      variation="primary"
                      size="medium"
                      extra={
                        <p
                          className={`
                          text-xs bg-white text-pry-green-200 font-medium
                          p-1 h-[20px] min-w-[20px] rounded-full
                          flex items-center justify-center
                          `}
                        >
                          {entry.approvalCount}
                        </p>
                      }
                    />
                  </div>,
                ],
              };
            }) ?? []
        }
        isTableEmpty={[0, undefined].includes(
          approvalSummary?.data?.totalapprovalCount
        )}
        emptyTitle="You have no pending approvals"
        emptySubTitle="All your cooperative approvals will be displayed here whenever you need to approve any action."
        emptrySrc="/assets/images/empty_approvals.svg"
        isLoading={fetchingApprovalSummary}
        loadingHeight={72}
        itemsPerPage={5}
        custLoader={<CoopCardLoader count={10} />}
        className="!border-spacing-y-3"
      />
    </div>
  );
};
